import { Link } from 'react-router-dom';
import { stats } from '@/mocks/stats';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=A%20warm%20abstract%20geometric%20pattern%20with%20flowing%20curves%20and%20soft%20organic%20shapes%20in%20amber%20gold%20and%20cream%20tones%2C%20representing%20community%20connection%20and%20social%20interaction%2C%20modern%20minimalist%20style%2C%20warm%20atmospheric%20lighting%2C%20no%20text%2C%20no%20people%2C%20artistic%20abstract%20design&width=1800&height=900&seq=hero-haijiao-01&orientation=landscape)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto text-center py-20">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
            海角论坛
            <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-3 text-background-200">
              汇聚真实分享，畅享社区互动
            </span>
          </h1>
          <p className="text-sm md:text-base text-background-300 max-w-2xl mx-auto mb-10 leading-relaxed">
            海角论坛是深受用户喜爱的网络社区平台，涵盖技术交流、生活杂谈、影视娱乐、游戏电竞等多元版块，
            为千万用户提供自由分享与交流的空间。无论你是技术达人、生活爱好者还是游戏玩家，都能在这里找到属于自己的天地。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
            <Link
              to="/category"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              探索版块
            </Link>
            <button className="px-8 py-3 bg-background-50/15 text-background-50 font-medium rounded-md border border-background-50/30 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm">
              立即注册
            </button>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50/10 backdrop-blur-sm border border-background-50/10"
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className={`${stat.icon} text-xl text-primary-400`}></i>
                </div>
                <span className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                  {stat.value}
                </span>
                <span className="text-xs text-background-300">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}